import apiClient from '@/services/PricingapiClient'
export default {
    //<!-----------------------------product page api's-------------------------------->
    getCoupons(token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/coupon')
    },
    /**
     * 
     * @param {*} form 
     */
    postCoupon(form, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/coupon/create', form)
    },
    /**
     * 
     * @param {*} id 
     */
    getCouponView(id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.get('/coupon/view/' + id)
    },
    /**
     * 
     * @param {*} form 
     * @param {*} id 
     */
    postCouponUpdate(form, id, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/coupon/update/' + id, form)
    },
    deletecoupon(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/coupon/singledelete/', data)
    },
    /**
     * product list
     */
    getProductList(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/coupon/productlist/', data)
    },
    /**
     * customer list
     */
    getCustomerList(data, token) {
        apiClient.defaults.headers.common['Authorization'] = `Bearer ${token}`;
        return apiClient.post('/coupon/customerlist/', data)
    },
}